export default "__VITE_ASSET__b43bc13b__"